<div class="pill" [ngClass]="{'checked': value === true}" (click)="toggle()" (mouseenter)="hoverIn()" (mouseleave)="hoverOut()">
    <span>
        {{text}}
        <ng-content></ng-content>
    </span>
</div>
